import { RootState } from "../index";
import { createDraftSafeSelector } from "@reduxjs/toolkit";

const selectAppReducer = (state: RootState) => state;

export const selectOrdersArchive = createDraftSafeSelector(
  selectAppReducer,
  (state) => state.dOrdersArchive,
);

export const selectOrdersArchiveFilters = createDraftSafeSelector(
  selectOrdersArchive,
  (state) => state.filters,
);

export const selectOrdersArchiveSearchString = createDraftSafeSelector(
  selectOrdersArchiveFilters,
  (state) => state?.searchString || "",
);

export const selectOrdersArchiveTableData = createDraftSafeSelector(
  selectOrdersArchive,
  (state) => state.data,
);

export const selectOrdersArchiveDetailItem = createDraftSafeSelector(
  selectOrdersArchive,
  (state) => state.detailItem,
);

export const selectOrdersArchivePagination = createDraftSafeSelector(
  selectOrdersArchive,
  (state) => state.pagination,
);
